import { type TRPCError } from "@trpc/server";
import { type DefaultErrorShape } from "@trpc/server/unstable-core-do-not-import";
import Decimal from "decimal.js";
import SuperJSON, { deserialize, parse, serialize, stringify } from "superjson";
import { ZodError } from "zod";

SuperJSON.registerCustom<Decimal, string>(
  {
    isApplicable: (v): v is Decimal => Decimal.isDecimal(v),
    serialize: (v) => v.toJSON(),
    deserialize: (v) => new Decimal(v),
  },
  "decimal.js",
);

export default SuperJSON;

export const errorFormatter = ({
  shape,
  error,
}: {
  shape: DefaultErrorShape;
  error: TRPCError;
}) => {
  return {
    ...shape,
    data: {
      ...shape.data,
      validationError:
        error.cause instanceof ZodError
          ? error.cause.flatten((c) => ({
              message: c.message,
              path: c.path,
            }))
          : null,
    },
  };
};

export { serialize, deserialize, stringify, parse };
